var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mall-order-complete"},[_c('div',{staticClass:"page"},[_c('MallResultMessage',{attrs:{"icon":_vm.resultIcon,"title":'결제가 완료되었어요',"messageLines":['주문 내역에서', '결제 정보를 확인할 수 있어요.']}}),_vm._v(" "),_c('MallBottomBar',{attrs:{"buttons":_vm.buttons},on:{"click":_vm.confirm}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a82073c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/new/MallOrderComplete.vue
// module id = null
// module chunks = 